import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Compre 1, leve 2',
  [OFFER_TYPE.FREE_ITEM]: 'Item gratuito',
  [OFFER_TYPE.AMOUNT_OFF]: 'Desconto em valor',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Desconto em percentagem',
};
